(function () {
  var STORAGE_KEY = 'adell_cookie_consent';
  var overlay = document.getElementById('acb-overlay');
  if (!overlay) return;

  function gcmDefault() {
    if (typeof gtag === 'function') {
      gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500
      });
    }
  }

  function withPrivacyApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
    });
  }

  function syncShopify(type) {
    var allow = type === 'all';
    withPrivacyApi(function (api) {
      var current = typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : null;
      var want = allow ? 'yes' : 'no';
      if (current && current.analytics === want && current.marketing === want && current.preferences === want) return;
      try {
        api.setTrackingConsent({ analytics: allow, marketing: allow, preferences: allow }, function () {});
      } catch (e) {}
    });
  }

  function gcmUpdate(type) {
    var granted = type === 'all' ? 'granted' : 'denied';
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        analytics_storage: granted,
        ad_storage: granted,
        ad_user_data: granted,
        ad_personalization: granted
      });
    }
    syncShopify(type);
    document.dispatchEvent(new CustomEvent('adell:cookie-consent', { detail: { type: type } }));
  }

  function getConsent() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  var lastFocus = null;

  function saveConsent(type) {
    try { localStorage.setItem(STORAGE_KEY, type); } catch (e) {}
    overlay.classList.remove('acb-visible');
    if (lastFocus && typeof lastFocus.focus === 'function' && lastFocus !== document.body) lastFocus.focus();
    lastFocus = null;
    requestAnimationFrame(function () { setTimeout(function () { gcmUpdate(type); }, 0); });
  }

  function openBanner(focus) {
    overlay.classList.add('acb-visible');
    if (!focus) return;
    lastFocus = document.activeElement;
    var first = document.getElementById('acb-accept-all');
    if (first) first.focus({ preventScroll: true });
  }

  document.getElementById('acb-accept-all').addEventListener('click', function () {
    saveConsent('all');
  });
  document.getElementById('acb-necessary-only').addEventListener('click', function () {
    saveConsent('necessary');
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-acb-open]');
    if (!link) return;
    e.preventDefault();
    openBanner(true);
  });

  gcmDefault();

  var existing = getConsent();
  if (existing) { gcmUpdate(existing); return; }

  setTimeout(function () { openBanner(false); }, 200);
})();
